import { render, staticRenderFns } from "./immavables.select.vue?vue&type=template&id=e4d3dada"
import script from "./immavables.select.vue?vue&type=script&lang=js"
export * from "./immavables.select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports